module.exports = __webpack_public_path__ + "static/img/ic_wdt.eeb207d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erp/ic_wdt.png
// module id = /fc3
// module chunks = 1